import { Link } from "react-router-dom";
import { getLatestNews, formatDate } from "@/utils/content";

export default function LatestNews() {
  const news = getLatestNews(3);

  return (
    <section className="bg-background-100 border-y border-background-200">
      <div className="max-w-site mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
          <div>
            <p className="text-xs md:text-sm font-medium tracking-[0.3em] text-accent-700 mb-3">
              LATEST NEWS
            </p>
            <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950 font-heading">
              最新动态
            </h2>
          </div>
          <Link
            to="/news"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部动态
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {news.map((item) => (
            <Link
              key={item.id}
              to={`/detail/${item.id}`}
              className="group flex flex-col bg-background-50 border border-background-200 rounded-lg p-6 hover:border-primary-300 transition-colors cursor-pointer h-full"
            >
              <div className="flex items-center gap-3 text-xs text-foreground-500 mb-4">
                <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900">
                  {item.category}
                </span>
                <span>{formatDate(item.date)}</span>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">
                {item.summary}
              </p>
              <span className="mt-5 inline-flex items-center gap-1 text-sm text-accent-700">
                阅读全文
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}